import { useState, useEffect } from "react";
import { onAuthStateChanged, type User } from "firebase/auth";
import { auth } from "./firebase";
import LoginPage from "./LoginPage";
import Dashboard from "./Dashboard";
import AnalyzePage, { type AnalysisResult, type PlayerInfo } from "./AnalyzePage";
import ResultsPage from "./ResultsPage";
import ComparisonPage from "./ComparisonPage";
import ProfilePage from "./ProfilePage";

export default function App() {
  const [screen, setScreen] = useState<
    "login" | "dashboard" | "analyze" | "results" | "comparison" | "profile"
  >("login");

  const [analysis, setAnalysis] = useState<AnalysisResult | null>(null);
  const [playerInfo, setPlayerInfo] = useState<PlayerInfo | null>(null);
  const [firebaseUser, setFirebaseUser] = useState<User | null>(null);

  // Listen to Firebase auth state — auto-login if already signed in
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setFirebaseUser(user);
      if (user && screen === "login") setScreen("dashboard");
    });
    return unsub;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Display name: Firebase > playerInfo form > fallback
  const playerName =
    firebaseUser?.displayName ||
    playerInfo?.name ||
    undefined;

  if (screen === "login")
    return (
      <LoginPage
        onLogin={(user) => {
          setFirebaseUser(user);
          setScreen("dashboard");
        }}
      />
    );

  if (screen === "dashboard")
    return (
      <Dashboard
        onNewAnalysis={() => setScreen("analyze")}
        onCompare={() => setScreen("comparison")}
        onProfile={() => setScreen("profile")}
        playerName={playerName}
      />
    );

  if (screen === "analyze")
    return (
      <AnalyzePage
        onBack={() => setScreen("dashboard")}
        uid={firebaseUser?.uid}
        onResults={(result, info) => {
          setAnalysis(result);
          setPlayerInfo(info);
          setScreen("results");
        }}
      />
    );

  if (screen === "results") {
    if (!analysis) {
      return (
        <div style={{ padding: 20 }}>
          No analysis found.
          <button onClick={() => setScreen("dashboard")}>Back</button>
        </div>
      );
    }
    return (
      <ResultsPage
        onBack={() => setScreen("dashboard")}
        analysis={analysis}
        playerInfo={playerInfo}
      />
    );
  }

  if (screen === "comparison")
    return <ComparisonPage onBack={() => setScreen("dashboard")} />;

  if (screen === "profile")
    return (
      <ProfilePage
        onBack={() => setScreen("dashboard")}
        onLogout={() => { setFirebaseUser(null); setScreen("login"); }}
        playerName={playerName}
      />
    );

  return <div>Coming soon</div>;
}